// Client-side relative-time formatter for announcement timestamps.
// Tuned for the dashboard's table-note row: short, glanceable, no clock noise.
//
// Convention: under a minute -> "just now"; under an hour -> "Nm ago";
// under a day -> "Nh ago"; under a week -> "Nd ago"; older -> "MMM D"
// (current year) or "MMM D, YYYY" (older years). All using the device locale.
//
// timestamp is milliseconds since epoch, matching the createdAt/updatedAt
// stamps the Convex announcements rows carry.

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

export const timeAgo = (timestamp, now = Date.now()) => {
  if (typeof timestamp !== 'number' || !Number.isFinite(timestamp)) return '';
  const delta = Math.max(0, now - timestamp);
  if (delta < MINUTE) return 'just now';
  if (delta < HOUR) {
    const mins = Math.floor(delta / MINUTE);
    return `${mins}m ago`;
  }
  if (delta < DAY) {
    const hours = Math.floor(delta / HOUR);
    return `${hours}h ago`;
  }
  if (delta < WEEK) {
    const days = Math.floor(delta / DAY);
    return `${days}d ago`;
  }
  // Older than a week — switch to absolute. Same year: "Mar 14"; older: "Mar 14, 2024".
  try {
    const d = new Date(timestamp);
    const nowYear = new Date(now).getFullYear();
    const options = d.getFullYear() === nowYear
      ? { month: 'short', day: 'numeric' }
      : { month: 'short', day: 'numeric', year: 'numeric' };
    return d.toLocaleDateString(undefined, options);
  } catch (_) {
    return '';
  }
};
